function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";

// Customizable Area Start
import { StyleSheet, Text, View, TextInput, Button, ScrollView, Platform, Image, TouchableOpacity, TouchableWithoutFeedback, KeyboardAvoidingView } from "react-native";
import CountryCodeSelector from "../../country-code-selector/src/CountryCodeSelector";
// Customizable Area End

import EmailAccountRegistrationController from "./EmailAccountRegistrationController";
export default class EmailAccountRegistration extends EmailAccountRegistrationController {
  constructor(props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }
  render() {
    return /*#__PURE__*/React.createElement(KeyboardAvoidingView, {
      behavior: this.isPlatformiOS() ? "padding" : undefined,
      style: styles.keyboardPadding
    }, /*#__PURE__*/React.createElement(ScrollView, {
      keyboardShouldPersistTaps: "always",
      style: styles.container
    }, /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
      testID: "Background",
      onPress: () => {
        this.hideKeyboard();
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
      style: styles.headline
    }, this.isPlatformWeb() ? /*#__PURE__*/React.createElement(Text, {
      style: styles.signUpText
    }, "Sign Up") : null, /*#__PURE__*/React.createElement(Text, {
      style: styles.titleWhySignUp
    }, this.labelHeader)), /*#__PURE__*/React.createElement(TextInput, _extends({
      testID: "txtInputFirstName",
      style: Platform.OS === "web" ? styles.inputWeb : styles.bgInput,
      placeholder: this.labelFirstName
    }, this.txtInputFirstNamePrpos)), /*#__PURE__*/React.createElement(TextInput, _extends({
      testID: "txtInputLastName",
      style: Platform.OS === "web" ? styles.inputWeb : styles.bgInput,
      placeholder: this.lastName
    }, this.txtInputLastNamePrpos)), /*#__PURE__*/React.createElement(TextInput, _extends({
      testID: "txtInputEmail",
      style: Platform.OS === "web" ? styles.inputWeb : styles.bgInput,
      placeholder: this.labelEmail
    }, this.txtInputEmailPrpos)), /*#__PURE__*/React.createElement(View, {
      style: styles.bgPasswordContainer
    }, /*#__PURE__*/React.createElement(TextInput, _extends({
      testID: "txtInputPassword",
      style: styles.bgPasswordInput,
      placeholder: this.labelPassword
    }, this.txtInputPasswordProps)), /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      testID: "btnPasswordShowHide",
      style: styles.passwordShowHide
    }, this.btnPasswordShowHideProps), /*#__PURE__*/React.createElement(Image, _extends({
      testID: "imgEnablePasswordField",
      style: styles.imgPasswordShowhide
    }, this.imgEnablePasswordFieldProps)))), /*#__PURE__*/React.createElement(Text, null, this.state.passwordHelperText), /*#__PURE__*/React.createElement(View, {
      style: styles.bgPasswordContainer
    }, /*#__PURE__*/React.createElement(TextInput, _extends({
      testID: "txtInputConfirmPassword",
      style: styles.bgPasswordInput,
      placeholder: this.labelRePassword
    }, this.txtInputConfirmPasswordProps)), /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      testID: "btnConfirmPasswordShowHide",
      style: styles.passwordShowHide
    }, this.btnConfirmPasswordShowHideProps), /*#__PURE__*/React.createElement(Image, _extends({
      testID: "imgEnableRePasswordField",
      style: styles.imgPasswordShowhide
    }, this.imgEnableRePasswordFieldProps)))), /*#__PURE__*/React.createElement(CountryCodeSelector, {
      allowPropChange: true,
      navigation: this.isPlatformWeb() ? null : this.props.navigation,
      id: "CountryCodeSelector",
      placeHolder: "Country Code",
      style: styles.bgRectBorder,
      disable: false,
      value: this.state.countryCodeSelected
    }), /*#__PURE__*/React.createElement(TextInput, _extends({
      testID: "txtPhoneNumber",
      style: Platform.OS === "web" ? styles.inputWeb : styles.bgInput,
      placeholder: "Phone"
    }, this.txtPhoneNumberProps)), /*#__PURE__*/React.createElement(Text, {
      style: styles.leagalText
    }, this.labelLegalText), /*#__PURE__*/React.createElement(View
    // eslint-disable-next-line react-native/no-inline-styles
    , {
      style: {
        flexDirection: "row",
        marginTop: 10,
        marginBottom: 30
      }
    }, /*#__PURE__*/React.createElement(Text, _extends({
      testID: "btnLegalTermsAndCondition",
      style: styles.btnLegalTermsAndCondition
    }, this.btnLegalTermsAndConditionProps), this.labelLegalTermCondition), /*#__PURE__*/React.createElement(Text, _extends({
      testID: "btnLegalPrivacyPolicy",
      style: styles.btnLegalPrivacyPolicy
    }, this.btnLegalPrivacyPolicyProps), this.labelLegalPrivacyPolicy)), /*#__PURE__*/React.createElement(Button, _extends({
      testID: "btnSignUp",
      title: this.btnTextSignUp,
      color: "#6200EE"
    }, this.btnSignUpProps))))));
  }
  async componentDidMount() {
    // Customizable Area Start
    this.getValidations();
    // Customizable Area End
  }
}
const styles = StyleSheet.create({
  // Customizable Area Start
  container: {
    flex: 1,
    padding: 16,
    marginLeft: "auto",
    marginRight: "auto",
    width: Platform.OS === "web" ? "75%" : "100%",
    maxWidth: 650,
    backgroundColor: "#fff"
  },
  titleWhySignUp: {
    marginBottom: 32,
    fontSize: 16,
    textAlign: "left",
    marginVertical: 8
  },
  titleOtpInfo: {
    marginBottom: 32,
    fontSize: 16,
    textAlign: "left",
    marginVertical: 8
  },
  bgInput: {
    flexDirection: "row",
    fontSize: 16,
    textAlign: "left",
    backgroundColor: "#00000000",
    marginTop: 24,
    borderWidth: 1,
    borderColor: "#767676",
    borderRadius: 2,
    includeFontPadding: true,
    padding: 10
  },
  inputWeb: {
    flex: 1,
    flexDirection: "row",
    marginTop: 24,
    fontSize: 18,
    padding: 10,
    borderBottomColor: "#767676",
    includeFontPadding: true,
    borderBottomWidth: 1
  },
  bgRectBorder: {
    borderWidth: 1,
    borderColor: "#767676",
    borderRadius: 2,
    marginBottom: 10
  },
  bgPasswordInput: {
    flex: 1,
    fontSize: 16,
    textAlign: "left",
    backgroundColor: "#00000000",
    minHeight: 40,
    includeFontPadding: true,
    marginTop: 10,
    paddingLeft: 0
  },
  passwordShowHide: {
    alignSelf: "center"
  },
  bgPasswordContainer: {
    flexDirection: "row",
    backgroundColor: "#00000000",
    marginBottom: 16,
    borderWidth: Platform.OS === "web" ? 0 : 1,
    borderBottomWidth: 1,
    borderColor: "#767676",
    borderRadius: 2,
    paddingLeft: 5,
    paddingRight: 5,
    zIndex: -1
  },
  imgPasswordShowhide: Platform.OS === "web" ? {
    height: 30,
    width: 30
  } : {},
  keyboardPadding: {
    flex: 1
  },
  btnLegalTermsAndCondition: {
    color: "#6200EE"
  },
  btnLegalPrivacyPolicy: {
    color: "#6200EE",
    marginLeft: "auto"
  },
  leagalText: {
    marginTop: 10
  },
  headline: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
  },
  signUpText: {
    fontSize: 32,
    color: "#6200EE",
    fontWeight: "bold"
  }
  // Customizable Area End
});